import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, switchMap, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { DataLayerManager } from '@agm/core';
import { forkJoin } from 'rxjs/'; // RxJS 6 syntax
import { env } from 'process';

@Injectable()
export class ProductsService {
  constructor(private http: HttpClient) {}

  public getToolkitProductById(id) {
    const headers = new HttpHeaders().set(environment.toolkitHeader, environment.toolkitKey);

    return this.http
      .get(environment.toolkitApi + 'public/items/' + id, { headers })
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Get All Products
  public getAllProducts(pagination, sort) {
    const sortString = '&sort=' + sort;

    let paginationString = '';
    paginationString += '?size=' + pagination.size;
    paginationString += '&page=' + pagination.page;

    return this.http
      .get(environment.apiUrl + 'api/ext-item' + paginationString + sortString, {
        observe: 'response',
      })
      .pipe(map(this.handleDataWithHeaders))
      .pipe(catchError(this.handleError));
  }

  public getAllProductsByStoreIdChunked(storeid) {
    const chunkSize = 2000;

    return this.http
      .get(environment.apiUrl + 'api/ext-item/by-store/' + storeid + '?size=' + 1 + '&page=' + 0, {
        observe: 'response',
      })
      .pipe(
        switchMap((res) => {
          const totalRecords = parseInt(res.headers.get('x-total-count'), 10);
          const totalPages = Math.ceil(totalRecords / chunkSize);
          const observableBatch = [];

          for (let i = 0; i < totalPages; i++) {
            observableBatch.push(this.getProductChunk(storeid, chunkSize, i));
          }

          return forkJoin(observableBatch);
        })
      )
      .pipe(catchError(this.handleError));
  }

  getProductChunk(storeid, pageSize, pageNum): Observable<any> {
    const sortString = '&sort=name,asc';
    return this.http.get(
      environment.apiUrl +
        'api/ext-item/by-store/' +
        storeid +
        '?size=' +
        pageSize +
        '&page=' +
        pageNum +
        sortString
    );
  }

  // public getAllProductsByStoreIdFullList2(storeid) {
  //   const sortString = '&sort=name,asc';

  //   let paginationString = '';
  //   paginationString += '?size=' + 999999;
  //   paginationString += '&page=' + 0;

  //   return this.http
  //     .get(
  //       environment.apiUrl + 'api/ext-item/by-store/' + storeid + paginationString + sortString,
  //       { observe: 'response' }
  //     )
  //     .pipe(map(this.handleDataWithHeaders))
  //     .pipe(catchError(this.handleError));
  // }

  public getAllProductsByStoreId(storeid, pagination, sort, filters) {
    // let filterString = '';
    // let searchString = '';
    const sortString = '&sort=' + sort;

    // tslint:disable-next-line:forin
    // for (const prop in filters) {
    //     if (prop !== 'submit' && filters[prop] !== '' && filters[prop] !== null) {
    //         filterString += '&' + prop + '=' + filters[prop];
    //     }
    // }

    // if (filterString !== '') {
    //     searchString = '/search/';
    // }

    let paginationString = '';
    paginationString += '?size=' + pagination.size;
    paginationString += '&page=' + pagination.page;

    // return this.http.get(environment.apiUrl + 'api/ext-item/by-store/' + storeid + searchString + paginationString + filterString + sortString, { observe: 'response' })
    return this.http
      .get(
        environment.apiUrl + 'api/ext-item/by-store/' + storeid + paginationString + sortString,
        { observe: 'response' }
      )
      .pipe(map(this.handleDataWithHeaders))
      .pipe(catchError(this.handleError));
  }

  public getAllProductsByCategory(catid, pagination, sort) {
    const sortString = '&sort=' + sort;

    let paginationString = '';
    paginationString += '?size=' + pagination.size;
    paginationString += '&page=' + pagination.page;

    return this.http
      .get(
        environment.apiUrl +
          'api/ext-item/by-item-category/' +
          catid +
          paginationString +
          sortString,
        { observe: 'response' }
      )
      .pipe(map(this.handleDataWithHeaders))
      .pipe(catchError(this.handleError));
  }

  public getProductById(id) {
    return this.http
      .get(environment.apiUrl + 'api/ext-item/' + id)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public createProduct(obj) {
    const body = {
      description: obj.description,
      discontinued: false,
      displayName: obj.displayName,
      ean: obj.ean,
      enabled: true,
      managed: false,
      name: obj.name,
      price: obj.price,
      productCode: obj.productCode,
      sortOrder: obj.sortOrder,
      allergensApiProductId: obj.allergensApiProductId,
      storeId: obj.storeId,
      itemCategoryId: obj.itemCategoryId,
      foodToGoCategoryId: obj.itemCategoryFoodToGoId,
      itemCategoryKioskId: obj.itemCategoryKioskId,
      alwaysInStock: true,
    };
    return this.http
      .post(environment.apiUrl + 'api/ext-item', body)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public editProduct(obj) {
    const body = {
      id: obj.id,
      description: obj.description,
      discontinued: obj.discontinued,
      displayName: obj.displayName,
      ean: obj.ean,
      enabled: obj.enabled,
      alwaysInStock: obj.alwaysInStock,
      managed: obj.managed,
      name: obj.name,
      price: obj.price,
      productCode: obj.productCode,
      sortOrder: obj.sortOrder,
      allergensApiProductId: obj.allergensApiProductId,
      storeId: obj.storeId,
      itemCategoryId: obj.categoryId,
      itemCategoryKioskId: obj.categoryKioskId,
      foodToGoCategoryId: obj.foodToGoCategoryId,
      nutrition: obj.nutrition,
      ingredients: obj.ingredients,
      ageRestriction: obj.ageRestriction,
    };
    return this.http
      .put(environment.apiUrl + 'api/ext-item', body)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public setEnabled(id, enabled) {
    // console.log('disable product', id);
    const body = {
      id: id,
      enabled: enabled,
    };
    return this.http
      .put(environment.apiUrl + 'api/ext-item', body)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public deleteProduct(id) {
    return this.http
      .delete(environment.apiUrl + 'api/ext-item/' + id)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Get all categories
  public getAllCategories(pagination, sort) {
    const sortString = '&sort=' + sort;

    let paginationString = '';
    paginationString += '?size=' + pagination.size;
    paginationString += '&page=' + pagination.page;

    return this.http
      .get(environment.apiUrl + 'api/ext-item-category' + paginationString + sortString, {
        observe: 'response',
      })
      .pipe(map(this.handleDataWithHeaders))
      .pipe(catchError(this.handleError));
  }

  // Get all categories with no pagination (for lists and dropdowns)
  public getAllCategoriesNoPagination() {
    let paginationString = '';
    paginationString += '?size=' + 10000;
    paginationString += '&page=' + 0;
    return this.http
      .get(environment.apiUrl + 'api/ext-item-category' + paginationString)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Get categories by Store Id
  public getItemCategoriesByStoreId(id) {
    return this.http
      .get(environment.apiUrl + 'api/ext-item-category/by-store/' + id)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Get all kiosk categories
  public getAllKioskCategories(pagination, sort) {
    const sortString = '&sort=' + sort;

    let paginationString = '';
    paginationString += '?size=' + pagination.size;
    paginationString += '&page=' + pagination.page;

    return this.http
      .get(environment.apiUrl + 'api/ext-item-category-kiosk' + paginationString + sortString, {
        observe: 'response',
      })
      .pipe(map(this.handleDataWithHeaders))
      .pipe(catchError(this.handleError));
  }

  // Get all kiosk categories with no pagination (for lists and dropdowns)
  public getAllKioskCategoriesNoPagination() {
    let paginationString = '';
    paginationString += '?size=' + 10000;
    paginationString += '&page=' + 0;
    return this.http
      .get(environment.apiUrl + 'api/ext-item-category-kiosk' + paginationString)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Get kiosk categories by Store Id
  public getItemKioskCategoriesByStoreId(id) {
    return this.http
      .get(environment.apiUrl + 'api/ext-item-category-kiosk/by-store/' + id)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // HANDLE DATA
  private handleData(res: HttpResponse<any>) {
    const body = res;
    return body;
  }

  public handleDataWithHeaders(res: HttpResponse<any>) {
    const headers = res.headers;
    const body = res.body;
    const data = {
      headers: headers,
      body: body,
    };
    return data;
  }

  private handleError(error: any) {
    return Observable.throw(new HttpErrorResponse(error));
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/products.service.ts